export default __webpack_public_path__ + "static/media/deposit_list_icon_black.197f1a94.svg";